// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messages-list .card-message:not(:last-child){margin-bottom:10px}.messages-list .card-message:not(:last-child):after{content:'';position:absolute;top:calc(100% + 4px);height:2px;left:15px;right:15px;background-color:#e3e3e3}.messages-list .card-message.active:after{display:none}\n", ""]);
// Exports
module.exports = exports;
